module.exports = __webpack_public_path__ + "static/media/usdc.405cc7bb.png";